import React from 'react'
import PropTypes from 'prop-types'
import Paragraphs from '../Paragraphs'
import { useBtn } from './hooks/useBtn'
import { Container } from './styles'

/**
 *  @author ehernandez
 * @param {propeties} propiedades to component
 * @returns {React.Component}
 */
const Button = ({
  size,
  label,
  shortcut,
  rounded,
  loading,
  type,
  uppercase,
  iconLeft,
  iconRight,
  onClick,
  disabled,
  mode,
  styles,
  form,
  id,
  border,
  transform,
  cy
}) => {
  const { classFromMode } = useBtn({
    mode,
    rounded,
    uppercase,
    border
  })

  return (
    // must be refactor this gradient mode
    <div className={`${mode === 'gradient' && !disabled ? 'tw-overflow-hidden tw-bg-gradient-to-br tw-from-primary  tw-rounded-full  tw-to-tertiary tw-p-[1px]' : null} `}>
    <Container
      data-cy={cy}
      data-testid={id}
      id={id}
      rounded={mode === 'gradient'}
      form={form}
      size={size}
      style={{ ...styles }}
      className={`button ${classFromMode(disabled)}`}
      disabled={disabled || loading}
      onClick={onClick}
      type={type}
    >
      <div
        className={`tw-flex tw-w-full  tw-items-center ${
          shortcut || iconRight || iconLeft
            ? 'tw-justify-between'
            : 'tw-justify-center'
        }`}
      >
        {iconLeft && <div className="tw-flex">{iconLeft}</div>}
        <div>
          <Paragraphs
            className={'button__label tw-text-center'}
            weight="bold"
            size="xs"
            transform={transform}
          >
            {label}
          </Paragraphs>
        </div>
        {shortcut && (
          <div className="tw-ml-2">
            <Paragraphs size="xxs">{shortcut}</Paragraphs>
          </div>
        )}

        {iconRight && <div className="tw-flex">{iconRight}</div>}
      </div>
    </Container>
    </div>
  )
}
Button.propTypes = {
  form: PropTypes.string,
  loading: PropTypes.bool,
  type: PropTypes.oneOf(['submit', 'button']),
  size: PropTypes.oneOf(['mini', 'small', 'medium', 'full']),
  mode: PropTypes.oneOf(['primary', 'secondary', 'transparent', 'white', 'transparent-border', 'gradient']),
  label: PropTypes.string.isRequired,
  shortcut: PropTypes.string,
  rounded: PropTypes.bool,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  uppercase: PropTypes.bool,
  iconLeft: PropTypes.node,
  iconRight: PropTypes.node,
  styles: PropTypes.object,
  id: PropTypes.string,
  border: PropTypes.oneOf(['primary', 'secondary', 'none']),
  transform: PropTypes.oneOf(['uppercase', 'lowercase', 'capitalize']),
  cy: PropTypes.string
}

Button.defaultProps = {
  mode: 'primary',
  rounded: false,
  disabled: false,
  size: 'full',
  onClick: null,
  icon: null,
  uppercase: false,
  loading: false,
  type: 'button',
  form: null,
  labelLeft: false,
  boder: 'none'
}

export default Button
